export const bolivia_bank: Array<{ codeBank: string; nameBank: string }> = [
    { codeBank: 'BNB', nameBank: 'Banco Nacional de Bolivia S.A.' },
    { codeBank: 'BME', nameBank: 'Banco Mercantil Santa Cruz S.A.' },
    { codeBank: 'BIS', nameBank: 'Banco Bisa S.A.' },
    { codeBank: 'BCR', nameBank: 'Banco de Crédito de Bolivia S.A.' },
    { codeBank: 'BEC', nameBank: 'Banco Económico S.A.' },
    { codeBank: 'BGA', nameBank: 'Banco Ganadero S.A.' },
    { codeBank: 'BSO', nameBank: 'Banco Solidario S.A.' },
    { codeBank: 'BNA', nameBank: 'Banco de la Nación Argentina' },
    { codeBank: 'BIE', nameBank: 'Banco para el Fomento a Iniciativas Económicas S.A.' },
    { codeBank: 'BFO', nameBank: 'Banco Fortaleza S.A.' },
    { codeBank: 'BPR', nameBank: 'Banco Prodem S.A.' },
    { codeBank: 'BPY', nameBank: 'Bancos PYME' },
    { codeBank: 'PCO', nameBank: 'Banco PYME de la Comunidad S.A.' },
    { codeBank: 'PEF', nameBank: 'Banco PYME Ecofuturo S.A.' },
    { codeBank: 'BDR', nameBank: 'Banco de Desarrollo Productivo S.A.M.' },
    { codeBank: 'BUN', nameBank: 'Banco Unión S.A.' },
    { codeBank: 'VL1', nameBank: 'La Primera Entidad Financiera de Vivienda' },
    { codeBank: 'VPR', nameBank: 'La Promotora Entidad Financiera de Vivienda' },
    { codeBank: 'VPG', nameBank: 'El Progreso Entidad Financiera de Vivienda' },
    { codeBank: 'CJN', nameBank: 'Coop. "Jesús Nazareno" R.L.' },
    { codeBank: 'CFA', nameBank: 'Coop. "Fátima" R.L.' },
    { codeBank: 'CSM', nameBank: 'Coop. "San Martín de Porres" R.L.' },
    { codeBank: 'CSA', nameBank: 'Coop. "San Antonio" R.L.' },
    { codeBank: 'CIH', nameBank: 'Coop. "Inca Huasi" R.L.' },
    { codeBank: 'CQC', nameBank: 'Coop. "Quillacollo" R.L.' },
    { codeBank: 'CJP', nameBank: 'Coop. "San José de Punata" R.L.' },
    { codeBank: 'CMM', nameBank: 'Coop. "Madre y Maestra" R.L.' },
    { codeBank: 'CLY', nameBank: 'Coop. "Loyola" R.L.' },
    { codeBank: 'CPX', nameBank: 'Coop. "Pío" X R.L.' },
    { codeBank: 'CCR', nameBank: 'Coop. "El Chorolque" R.L.' },
    { codeBank: 'CSP', nameBank: 'Coop. "San Pedro" R.L.' },
    { codeBank: 'CCP', nameBank: 'Coop. "Catedral" R.L.' },
    { codeBank: 'CCM', nameBank: 'Coop. "Comarapa" R.L.' },
    { codeBank: 'CTR', nameBank: 'Coop. "Trinidad" R.L.' },
    { codeBank: 'CEC', nameBank: 'Coop. "Educadores Gran Chaco" R.L.' },
    { codeBank: 'CST', nameBank: 'Coop. "San Mateo" R.L.' },
    { codeBank: 'CMG', nameBank: 'Coop. "Monseñor Félix Gainza" R.L.' },
    { codeBank: 'CMR', nameBank: 'Coop. "Magisterio Rural" R.L.' },
    { codeBank: 'CJB', nameBank: 'Coop. "San José de Bermejo" R.L.' },
    { codeBank: 'CJO', nameBank: 'Coop. "San Joaquín" R.L.' },
    { codeBank: 'CSR', nameBank: 'Coop. "San Roque" R.L.' },
    { codeBank: 'CAS', nameBank: 'Coop. "Asunción" R.L.' },
    { codeBank: 'CCA', nameBank: 'Coop. "Catedral de Tarija" R.L.' },
    { codeBank: 'CME', nameBank: 'Coop. "La Merced" R.L.' },
    { codeBank: 'CCB', nameBank: 'Coop. "San Carlos Borromeo" R.L.' },
    { codeBank: 'CCF', nameBank: 'Coop. "CACEF" R.L.' },
    { codeBank: 'CPG', nameBank: 'Coop. "Progreso" R.L.' },
    { codeBank: 'CLS', nameBank: 'Coop. "La Sagrada Familia" R.L.' },
    { codeBank: 'CMD', nameBank: 'Coop. "Magisterio Rural de Chuquisaca" R.L.' },
    { codeBank: 'CSN', nameBank: 'Coop. "San Martín" R.L.' },
    { codeBank: 'CSQ', nameBank: 'Coop. "San Pedro de Aiquile" R.L.' },
    { codeBank: 'CVE', nameBank: 'Coop. "Virgen de los Remedios" R.L.' },
    { codeBank: 'CLO', nameBank: 'Coop. "San Francisco Solano" R.L.' },
    { codeBank: 'CLC', nameBank: 'Coop. "Solucredit San Silvestre" R.L.' },
    { codeBank: 'COO', nameBank: 'Coop. "COOPROLE" R.L.' },
    { codeBank: 'CEY', nameBank: 'Coop. "Cristo Rey Cochabamba" R.L.' },
    { codeBank: 'CPS', nameBank: 'Coop. "Paulo VI" R.L.' },
    { codeBank: 'CUM', nameBank: 'Coop. "Unión Santiago de Machaca USAMA" R.L.' },
    { codeBank: 'CAE', nameBank: 'Coop. "Cantera" R.L.' },
    { codeBank: 'CHO', nameBank: 'Coop. "Hospicio" R.L.' },
    { codeBank: 'ICI', nameBank: 'Institución Financiera de Desarrollo CIDRE IFD' },
    { codeBank: 'ICR', nameBank: 'Institución Financiera de Desarrollo CRECER IFD' },
    { codeBank: 'IDI', nameBank: 'Institución Financiera de Desarrollo DIACONÍA FRID - IFD' },
    { codeBank: 'IFO', nameBank: 'Institución Financiera de Desarrollo FONDECO IFD' },
    { codeBank: 'IFU', nameBank: 'Institución Financiera de Desarrollo FUBODE IFD' },
    { codeBank: 'IID', nameBank: 'Institución Financiera de Desarrollo IDEPRO IFD' },
    { codeBank: 'IIM', nameBank: 'Institución Financiera de Desarrollo IMPRO IFD' },
    { codeBank: 'IPM', nameBank: 'Institución Financiera de Desarrollo Fundación PRO MUJER IFD' }
];
